import React, {useState} from 'react';
import {Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Spinner} from 'reactstrap';
import {addDoc, collection} from "firebase/firestore";
import {getDb} from "../../util/Constants";


function AddRegion(props) {
    const [load, setLoad] = useState(false)
    const [region, setRegion] = useState("")


    const handleSubmit = async (e) => {

        e.preventDefault()
        setLoad(true);
        let dataCapital=region.charAt(0).toUpperCase() + region.slice(1)
        const payload = {
            region: dataCapital
        }
        const docRef = await addDoc(collection(getDb(), "regions"), payload)
        props.getRegions();
        // props.setRegions((current) => [...current, { region: region }])

        setLoad(false)
        props.toggle()
        setRegion("")
    };


    return (
        <div>

            <Modal isOpen={props.modal} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}>Add Region</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <div className="">

                            <FormGroup>
                                <Label for="department">
                                    Region Name
                                </Label>
                                <Input
                                    type="text"
                                    id="department"
                                    maxLength={20}
                                    value={region}
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setRegion(e.target.value)}
                                />

                            </FormGroup>
                        </div>
                        <Button color="primary" type={"submit"} disabled={load}>
                            {load ? (
                                <Spinner color="light" size="sm" />
                            ) : (
                                "Save"
                            )}
                        </Button>
                        <Button color="secondary" onClick={props.toggle}>
                            Cancel
                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </div>);
}

export default AddRegion;